<template>
  <div v-if="visible" :class="containerClass">
    <div class="card shadow border-0 h-100">
      <div class="card-header text-dark py-2" :style="headerStyle">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0 fw-bold small">
            <AppIcon :name="`bi bi-${icon} me-1`" v-if="icon" :class="`bi bi-${icon} me-1`" />
            {{ title }}
          </h6>
          <slot name="trend"></slot>
        </div>
      </div>
      <div class="card-body text-center py-3">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsightCard',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    },

    headerStyle: {
      type: String,
      default: 'background-color: #f5f6fa !important;'
    },
    containerClass: {
      type: String,
      default: 'col-lg-3 col-md-6 mb-3'
    }
  }
};
</script>

<style scoped>
.card {
  border-radius: 12px;
  overflow: hidden;
}

.card-header {
  border-radius: 12px 12px 0 0 !important;
}
</style>
